import React, { useEffect, useState } from 'react';
import css from './index.module.scss';
import LightningIcon from '../Icons/Lightning/Lightning_icon.svg';
import { Switch, styled } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const LightningPayToggle = ({
  checked,
  checkLightningPay,
  toggleLighteningPayHandler,
  cardToken,
}) => {
  // TODO: THIS CODE HAS BEEN COMMENTED DUE TO SPWAP-407
  // const [toggleState, setToggleState] = useState(checked);
  // useEffect(() => {
  //   debugger;
  //   setToggleState((prev) => (checked ? true : false));
  // }, [checked]);

  return (
    <div className={css.root}>
      <div className={css.icon}>
        <img src={LightningIcon} alt="Lightning Pay Icon" />
      </div>
      <div className={css.text}>
        <FormattedMessage id="lightning_pay_title" defaultMessage="Lightning pay" />
      </div>
      <div className={css.toggle}>
        <IOSSwitch
          checked={checked}
          sx={{ m: 1 }}
          onChange={(status) => {
            if (!checked) {
              checkLightningPay && checkLightningPay(true);
            } else {
              toggleLighteningPayHandler && toggleLighteningPayHandler(false, cardToken);
            }
          }}
        />
      </div>
    </div>
  );
};

export default LightningPayToggle;
